module.exports = __webpack_public_path__ + "img/IMG_9022_L_WoodMatted.30f06d07.jpg";